import React, { useState } from 'react';

const JSONNestedKeyExtractor = () => {
    const [jsonInput, setJsonInput] = useState('');
    const [keyPath, setKeyPath] = useState('');
    const [extractedValue, setExtractedValue] = useState('');
    const [error, setError] = useState('');
    const [copySuccess, setCopySuccess] = useState(false);

    const exampleJSON = `{
        "user": {
            "name": "Alice",
            "age": 30,
            "address": {
                "city": "New York",
                "zip": "10001"
            }
        }
    }`;

    const exampleKeyPath = 'user.address.city';

    const extractKey = () => {
        try {
            const jsonObject = JSON.parse(jsonInput);
            const keys = keyPath.split('.');
            let value = jsonObject;

            for (const key of keys) {
                if (value[key] !== undefined) {
                    value = value[key];
                } else {
                    throw new Error(`Key path '${keyPath}' does not exist in the JSON object.`);
                }
            }

            setExtractedValue(JSON.stringify(value, null, 2));
            setError('');
            setCopySuccess(false);
        } catch (err) {
            setExtractedValue('');
            setError(err.message || 'Invalid JSON or key path. Please check your input.');
            setCopySuccess(false);
        }
    };

    const clearInputs = () => {
        setJsonInput('');
        setKeyPath('');
        setExtractedValue('');
        setError('');
        setCopySuccess(false);
    };

    const useExampleData = () => {
        setJsonInput(exampleJSON);
        setKeyPath(exampleKeyPath);
        setExtractedValue('');
        setError('');
        setCopySuccess(false);
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(extractedValue);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
    };

    return (
        <div className="container mt-4">
            {/* Example Data Button */}
            <div className="text-center mb-3">
                <button className="btn btn-info" onClick={useExampleData}>
                    Use Example Data
                </button>
            </div>

            {/* JSON Input Field */}
            <textarea
                className="form-control mb-3"
                rows="10"
                value={jsonInput}
                onChange={(e) => setJsonInput(e.target.value)}
                placeholder="Enter JSON object here..."
                style={{ border: '2px solid #ccc', borderRadius: '5px' }}
            />

            {/* Key Path Input Field */}
            <input
                type="text"
                className="form-control mb-3"
                value={keyPath}
                onChange={(e) => setKeyPath(e.target.value)}
                placeholder="Enter key path (e.g., user.address.city)"
                style={{ border: '2px solid #ccc', borderRadius: '5px' }}
            />

            {/* Action Buttons */}
            <div className="text-center">
                <button className="btn btn-success me-2" onClick={extractKey}>
                    Extract Value
                </button>
                <button className="btn btn-secondary" onClick={clearInputs}>
                    Clear
                </button>
            </div>

            {/* Error Display */}
            {error && (
                <p className="text-danger text-center mt-3">
                    <strong>Error:</strong> {error}
                </p>
            )}

            {/* Extracted Value Display */}
            {extractedValue && (
                <div className="mt-4">
                    <h3>Extracted Value</h3>
                    <pre
                        className="p-3"
                        style={{
                            backgroundColor: '#f5f5f5',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                        }}
                    >
                        {extractedValue}
                    </pre>
                    <div className="text-center mt-2">
                        <button
                            className={`btn ${copySuccess ? 'btn-success' : 'btn-primary'}`}
                            onClick={handleCopy}
                        >
                            {copySuccess ? 'Copied!' : 'Copy Output'}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default JSONNestedKeyExtractor;